import { ViewportDevice } from 'utils/constants';

const NO_HEADER_ROUTES = ['/components', '/course-set-up', '/profile-setup'];
const PUBLIC_UTILITY_ROUTES = ['/api-launch', '/components'];

const isNoHeaderRoute = (pathname) => NO_HEADER_ROUTES.some((route) => pathname.endsWith(route));
const isSidebarDevice = (device) => [ViewportDevice.DESKTOP, ViewportDevice.TABLET].includes(device);

const shouldShowLogoOnlyHeader = (auth, pathname) =>
    pathname.endsWith('/lti-incomplete') ||
    pathname.endsWith('/session-expired') ||
    (!auth && !PUBLIC_UTILITY_ROUTES.includes(pathname));

const shouldShowNavigation = (auth, pathname) => Boolean(auth) && !isNoHeaderRoute(pathname);
const shouldUseSidebarLayout = (auth, device, pathname) =>
    isSidebarDevice(device) && shouldShowNavigation(auth, pathname);

export { shouldShowLogoOnlyHeader, shouldShowNavigation, shouldUseSidebarLayout };
